import React, { useContext } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { Alert, Avatar, Button, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Check from '@mui/icons-material/Check'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { VehicleContext } from '../SingleVehicle'
import { SectionHeader } from './SectionKit'

const CleaningSection = () => {
  const { vehicle } = useContext(VehicleContext)
  const navigate = useNavigate()
  const cleans = vehicle?.cleans ?? []

  const lastDeepClean = vehicle?.lastDeepClean?.end
  const weeksSinceDeepClean = lastDeepClean
    ? moment().diff(moment(lastDeepClean), 'weeks')
    : null

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Vehicle Cleaning"
        caption="Cleans and decontaminations recorded against this vehicle"
        action={
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => navigate('/vehicle-clean?vehicle=' + vehicle._id)}
          >
            Record Clean
          </Button>
        }
      />
      {weeksSinceDeepClean !== null && weeksSinceDeepClean > 12 && (
        <Alert severity="error">
          Deep clean overdue — last deep clean was{' '}
          {moment(lastDeepClean).format('Do MMM YYYY')}.
        </Alert>
      )}
      {weeksSinceDeepClean !== null &&
        weeksSinceDeepClean >= 10 &&
        weeksSinceDeepClean <= 12 && (
          <Alert severity="warning">
            Deep clean due soon — last deep clean was{' '}
            {moment(lastDeepClean).format('Do MMM YYYY')}.
          </Alert>
        )}
      {cleans.length === 0 ? (
        <Alert severity="info">No cleans recorded for this vehicle yet.</Alert>
      ) : (
        <CustomDataGrid
          rows={cleans}
          columns={[
            {
              field: 'start',
              headerName: 'Start',
              minWidth: 150,
              renderCell: ({ row }) =>
                moment(row.start).format('DD/MM/YYYY HH:mm'),
            },
            {
              field: 'end',
              headerName: 'End',
              minWidth: 150,
              renderCell: ({ row }) =>
                moment(row.end).format('DD/MM/YYYY HH:mm'),
            },
            {
              field: 'operative',
              headerName: 'Operative',
              flex: 1,
              minWidth: 200,
              valueGetter: (value, row) =>
                `${row.operative.userAccount.firstName} ${row.operative.userAccount.lastName}`,
              renderCell: ({ row }) => (
                <Stack direction="row" alignItems="center" gap={1}>
                  <Avatar
                    src={row.operative.userAccount?.photograph}
                    sx={{ width: 28, height: 28 }}
                  />
                  <Typography variant="body2">
                    {row.operative.userAccount.firstName}{' '}
                    {row.operative.userAccount.lastName}
                  </Typography>
                </Stack>
              ),
            },
            {
              field: 'cleanType',
              headerName: 'Clean Type',
              minWidth: 150,
            },
            {
              field: 'deconReason',
              headerName: 'Decon Reason',
              minWidth: 150,
            },
            {
              field: 'atpTestCompleted',
              headerName: 'ATP Test',
              minWidth: 100,
              renderCell: ({ row }) =>
                row?.atpTestCompleted && <Check color="success" />,
              align: 'center',
              headerAlign: 'center',
            },
          ]}
          getRowId={(params) => params._id}
          disableRowSelectionOnClick
          onRowClick={({ row }) => navigate('/vehicle-clean/' + row._id)}
          initialState={{
            columns: {
              columnVisibilityModel: {
                deconReason: false,
              },
            },
            sorting: {
              sortModel: [{ field: 'start', sort: 'desc' }],
            },
          }}
        />
      )}
    </Stack>
  )
}

export default CleaningSection
